// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Atividade',
    add_check_list_item_placeholder: 'Adicionar item de checklist ou use Ctrl+V para colar uma lista de itens',
    add_checklist_label: 'Adicionar checklist',
    add_more: 'Adicionar mais',
    ai: 'IA',
    ai_analyzing: 'Analisando padrões',
    ai_building: 'Construindo modelo de previsão',
    ai_description: 'A previsão de IA do {brandName} está usando algoritmos de aprendizado de máquina para encontrar padrões e relacionamentos entre eventos e ações ao processar os dados históricos de sua conta. Como resultado, mostrará a data de término do projeto mais provável e sua confiança nesta previsão.',
    ai_forecast: 'Previsão de IA',
    ai_forecast_date: 'Data de término do projeto prevista pela IA',
    ai_how_works: 'Saiba mais sobre como a IA funciona',
    ai_not_enough_data: 'Não há dados históricos suficientes para fazer uma previsão confiável. Utilizar o sistema ativamente garantirá previsões mais precisas. <a href={0} target=\'_blank\' class={1}>Saiba mais</a> sobre a previsão de IA.',
    ai_planned_date: 'Data de término do projeto planejada',
    ai_result: 'Resultados da previsão de IA',
    ai_reviewing: 'Revisando dados históricos',
    apply: 'Aplicar',
    available: 'Disponível',
    back: 'Voltar',
    CanChangeWorkflowForProjectOutdatedData: 'O fluxo de trabalho já foi aplicado ao projeto. Atualize a página para atualizar os dados.',
    CanDeleteCategoryHasTask: 'É impossível excluir a categoria que está sendo usada em atividades.',
    CanDeletePriorityHasProject: 'É impossível excluir a prioridade que está sendo usada em projetos.',
    CanDeletePriorityHasTask: 'É impossível excluir a prioridade que está sendo usada em atividades.',
    CanDeletePriorityIsInternal: 'É impossível excluir a prioridade interna do sistema.',
    CanDeleteStatusIsWorkflowTypeStatus: 'É impossível excluir o status padrão.',
    CanDeleteStatusUsed: 'É impossível excluir o status que está sendo usado em qualquer entidade.',
    CanDeleteThresholdIsInternal: 'É impossível excluir o limiar interno do sistema.',
    CanDeleteVacationTypeDefault: 'É impossível excluir o tipo de férias padrão.',
    CanDeleteVacationTypeHasVacation: 'É impossível excluir o tipo de férias que possui férias atribuídas.',
    CanDeleteWorkflowIsSingle: 'Deve haver pelo menos um fluxo de trabalho no sistema.',
    CanDeleteWorkflowIsUsed: 'É impossível excluir o fluxo de trabalho que está sendo usado em projetos.',
    CanDisableStatusIsUsed: 'É impossível desativar o status que está sendo usado na entidade',
    CanDisableStatusIsWorkflowTypeStatus: 'É impossível desativar o status padrão',
    CanEdit_Task_AccessDenied: 'Você não tem permissão para editar esta atividade',
    CanEditValueThresholdIsInternal: 'Os valores de limiar do sistema predefinidos não podem ser alterados.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'É impossível definir o status como padrão para um status que já é padrão.',
    change: 'mudar',
    ChangeProjectProgressError: 'O progresso de um projeto com tarefas não pode ser editado.',
    ChangeTaskProgressError: 'O progresso de uma tarefa pai não pode ser editado.',
    check_all_label: 'Marcar todos',
    checklist_name: 'Lista de verificação',
    column_group_custom_fields: 'Campos personalizados',
    column_group_custom_fields_user: 'Campos personalizados do usuário',
    columns: 'Colunas',
    Completed_Projects: 'Projetos concluídos',
    Completed_Tasks: 'Atividades concluídas',
    Copy_Text: 'Copiar',
    copyPostfix: 'Copiar',
    create: 'Criar',
    created_by: 'Criado por',
    creation_date: 'Data de criação',
    current_plan: 'Plano atual: <b>{0}</b>',
    dates: 'Datas',
    delete_checklist_label: 'Excluir lista de verificação',
    description_title: 'Descrição',
    edit_check_list_item_placeholder: 'Editar item de checklist',
    Edit_Text: 'Editar',
    emoji: 'Emoji',
    empty_list: 'Nenhum resultado encontrado para corresponder à consulta/filtro aplicado',
    error_reload: 'A versão do {brandName} foi atualizada. Para o correto funcionamento do aplicativo, é necessário recarregar a página.',
    export: 'Exportar',
    export_csv: 'Exportar para CSV',
    export_pdf: 'Exportar para PDF',
    filters: 'Filtros',
    freeze: 'Congelar coluna',
    from: 'De',
    general: 'Geral',
    global_search: 'Buscar',
    global_search_text: 'Buscar mensagens, arquivos e mais',
    GotIt: 'Entendi',
    group_by: 'Agrupar por',
    group_by_template: 'Agrupar por: {0}',
    here: 'aqui',
    hourly_rate_unit: '/hr',
    icons: 'Ícones',
    in: 'em',
    in_use: 'Em uso',
    items_text: '1#{0} item#{0} itens',
    job_role: 'Cargo',
    label_custom_date_range: 'Intervalo de datas personalizado',
    label_daily: 'Diário',
    label_monthly: 'Mensal',
    label_weekly: 'Semanal',
    label_yearly: 'Anual',
    least_likely: 'Menos provável',
    month: 'Mês',
    MoreActions: 'Mais ações',
    most_likely: 'Mais provável',
    move_down: 'Mover para baixo',
    move_up: 'Mover para cima',
    name_title: 'Nome',
    next_month: 'Próximo mês',
    next_week: 'Próxima semana',
    no: 'Não',
    no_available_filters: 'Sem valores disponíveis para o filtro',
    no_data_to_display: 'Não há dados para exibir',
    NoPermissionToArchiveProject: 'A ação solicitada (arquivar projeto) não está disponível pelo seguinte motivo: você não tem permissão para arquivar o projeto.',
    not_calculated: 'Não calculado',
    not_in_use: 'Não em uso',
    pause: 'Pausar',
    PortfolioLimitError: 'Você atingiu o limite de 60 portfólios na Edição de Equipe. Atualize para a Edição Empresarial do {brandName}.',
    previous_month: 'Mês anterior',
    previous_week: 'Semana anterior',
    previous_year: 'Ano anterior',
    qb_disconnect_denied: 'Você não possui um token do QuickBooks associado a esta conta',
    quarter: 'Trimestre',
    quick_search_placeholder: 'Buscar por ID ou nome',
    quick_search_placeholder_for_archive: 'Pesquise projetos arquivados por nome ou ID',
    RateLimitExceededByAccount: 'Pedimos desculpas pelo inconveniente, mas devido ao alto tráfego, atualmente estamos limitando o número de solicitações que você pode fazer. Por favor, tente novamente mais tarde.',
    RateLimitExceededByUser: 'Pedimos desculpas pelo inconveniente, mas devido ao alto tráfego, atualmente estamos limitando o número de solicitações que você pode fazer. Por favor, tente novamente mais tarde.',
    read_more: 'Saiba mais',
    RecordConversionToActivityDifferentWorkflows: 'É impossível converter o registro, pois foram aplicados fluxos de trabalho diferentes ao projeto e ao modelo.',
    remove_checklist_item_label: 'Remover item da lista de verificação',
    request_resources: 'Solicitar recursos',
    reset_timer_title: 'Redefinir temporizador',
    resource_type_label: 'Tipo de recurso',
    resume: 'Continuar',
    role: 'Função',
    schedule_hours: 'Horas programadas',
    security_group: 'Nível de acesso',
    select: 'Selecionar',
    share: 'Compartilhar',
    short_quarter0: 'T1',
    short_quarter1: 'T2',
    short_quarter2: 'T3',
    short_quarter3: 'T4',
    show: 'Mostrar',
    show_template: 'Mostrar: {0}',
    skillsDeleteConfirm: 'A habilidade será removida dos perfis de outros usuários e funções de trabalho onde está sendo usada',
    SnapshotsLimitError: 'Você atingiu o limite de 3 instantâneos de projeto. Por favor, atualize para {brandName} Enterprise Edition.',
    sort: 'Ordenar',
    sort_activities: 'Ordenar atividades por:',
    sort_ascending: 'Ordenar ascendente',
    sort_az: 'Ordenar A→Z',
    sort_descending: 'Ordenar descendente',
    sort_projects: 'Ordenar projetos por:',
    sort_resources: 'Ordenar recursos por:',
    sort_za: 'Ordenar Z→A',
    start: 'Iniciar',
    start_analyze: 'Iniciar Análise',
    start_new_project: 'Iniciar novo projeto',
    stop_timer_title: 'Parar temporizador',
    sub_features_list_title: 'Este recurso inclui:',
    SystemTaskCreatorName: 'Sistema',
    Task_CanAccessBillingInformation_AccessDenied: 'Você não tem permissão para editar as configurações de faturamento desta atividade',
    this_month: 'Este mês',
    this_week: 'Esta semana',
    this_year: 'Este ano',
    ThresholdValueDuplicate: 'Este valor de limite já foi adicionado.',
    TimeoutErrorMessage: 'Sua solicitação expirou. Por favor, tente novamente mais tarde.',
    to: 'Para',
    today: 'Hoje',
    uncheck_all_label: 'Desmarcar tudo',
    unfreeze: 'Descongelar coluna',
    UnknownErrorMessage: 'Desculpe, algo deu errado... Por favor, atualize a página.',
    upgrade: 'Atualizar',
    upgrade_to_enterprise: 'Atualizar para Empresa',
    usage: 'Uso',
    week: 'Semana',
    WindowUnload_UnsavedChanges: 'Existem alterações não salvas. Você tem certeza de que deseja sair desta página?',
    year: 'Ano',
    yes: 'Sim',
    yesterday: 'Ontem',
};
